/**
 * useCurrentUser — the signed-in person's record from GET /v1/auth/me, which
 * the login response and the stored session do not carry.
 */
import { useQuery } from '@tanstack/react-query';

import { useAuth } from '../contexts/AuthContext';
import { getCurrentUser } from '../utils/api';

export interface CurrentUser {
  user_id: string;
  name?: string | null;
  /** The admin to name to this person, or null when /me names nobody. */
  invited_by_name?: string | null;
}

export function useCurrentUser() {
  const { isAuthenticated, user } = useAuth();
  return useQuery<CurrentUser, Error>({
    queryKey: ['currentUser', user?.user_id],
    enabled: isAuthenticated && !!user?.user_id,
    queryFn: () => getCurrentUser(),
  });
}
